import styled from "styled-components";

export const StyledWebhookTableCellWrapper = styled.div`
    padding: 20px 8px !important;
`;
